(() => {
  function initialize(root) {
    root.querySelectorAll('[data-imported-reviews]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const list = section.querySelector('[data-review-list]');
      const entries = Array.from(list.querySelectorAll('[data-review-entry]'));
      const size = Math.max(1, Number(section.dataset.pageSize) || 5);
      const pages = Math.ceil(entries.length / size);
      const prev = section.querySelector('[data-review-prev]');
      const next = section.querySelector('[data-review-next]');
      const sort = section.querySelector('[data-review-sort]');
      let page = 0;
      const order = () => {
        entries.sort((a,b) => (sort.value === 'oldest' ? 1 : -1) * a.dataset.reviewDate.localeCompare(b.dataset.reviewDate));
        entries.forEach(entry => list.append(entry));
      };
      const render = (moveFocus = false) => {
        entries.forEach((entry,index) => { entry.hidden = index < page * size || index >= (page + 1) * size; });
        prev.disabled = page === 0;
        next.disabled = page === pages - 1;
        section.querySelector('[data-review-page]').textContent = `Page ${page + 1} of ${pages}`;
        section.querySelector('[data-review-status]').textContent = `Showing ${page * size + 1}–${Math.min((page + 1) * size, entries.length)} of ${entries.length} reviews`;
        section.querySelector('[data-review-pagination]').hidden = pages <= 1;
        if (moveFocus) {
          section.querySelector('h2').focus({preventScroll:true});
          section.scrollIntoView({block:'start',behavior:'instant'});
        }
      };
      section.querySelector('[data-review-tools]').hidden = entries.length < 2;
      prev.addEventListener('click', () => { if(page>0){ page--; render(true); } });
      next.addEventListener('click', () => { if(page<pages-1){ page++; render(true); } });
      sort.addEventListener('change', () => { page = 0; order(); render(); });
      order(); render();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
